<template>
  <div>
    <h2 class="bb-page-title">Financial Snapshot</h2>
    <div class="bb-balance-accounts">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <Table :options="options"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Table from '@/components/Main/Table/Table'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import balanceAccountsApi from '@/api/BalanceAccounts/api'
import {balanceAccountsTable, balanceAccountsTableColumns} from '@/constants/TablesOptions/balanceAccountsTable'
import CacheApi from '@/api/CacheRegister/api'

export default {
  name: 'FinanceAssetsMaterialsRecords',
  components: {
    Table,
    LoaderFly
  },
  data: function () {
    return {
      loaderRun: false,
      options: balanceAccountsTable,
      bankBalances: [
        {
          category: 1,
          name: 'Emirates NBD',
          credit: 0,
          debit: 0
        },
        {
          category: 1,
          name: 'Mashreq Bank',
          credit: 0,
          debit: 0
        },
        {
          category: 1,
          name: 'RAK Bank',
          credit: 0,
          debit: 0
        },
        {
          category: 2,
          name: 'Credit Card',
          debit: 0
        },
        {
          category: 3,
          name: 'Cash on hand',
          credit: 0
        },
        {
          category: 5,
          name: 'Partner payouts',
          debit: 0
        },
        {
          category: 4,
          name: 'VAT',
          debit: 0
        }
      ]
    }
  },
  computed: {
    balanceAccountsColumnsData: {
      get: function () {
        return this.$store.getters.balanceAccountsColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setBalanceAccountsColumnsData', data)
      }
    },
    balanceAccountsRowsData: {
      get: function () {
        return this.$store.getters.balanceAccountsRowsData
      },
      set: function (data) {
        this.$store.dispatch('setBalanceAccountsRowsData', data)
      }
    }
  },
  methods: {
    addEditAccess (item) {
      if (item.category === 2 || item.category === 4) {
        item.noEdit = {
          credit: true
        }
      } else if (item.category === 1) {
        item.noEdit = {
          debit: true
        }
      } else if (item.category === 3) {
        item.static = true
      }
      if (!item.noEdit) {
        item.static = true
      }
    },
    addActions () {
      _.forEach(this.balanceAccountsColumnsData, item => {
        if (item.actions) {
          item.actions.edit = this.editBankBalance
        }
      })
    },
    getBankDetails () {
      this.loaderRun = true
      balanceAccountsApi.getBankBalance()
        .then((resp) => {
          this.balanceAccountsRowsData = resp.data.bankBalances
          if (resp.data.bankBalances.length === 0) {
            this.createStartBanks()
          } else {
            const emirates = _.find(this.balanceAccountsRowsData, {name: 'Emirates NBD'})
            const mashreq = _.find(this.balanceAccountsRowsData, {name: 'Mashreq Bank'})
            const rak = _.find(this.balanceAccountsRowsData, {name: 'RAK Bank'})
            const creditCard = _.find(this.balanceAccountsRowsData, {category: 2})
            const cash = _.find(this.balanceAccountsRowsData, {category: 3})
            const partners = _.find(this.balanceAccountsRowsData, {category: 5})
            const vat = _.find(this.balanceAccountsRowsData, {category: 4})
            this.balanceAccountsRowsData[0] = emirates
            this.balanceAccountsRowsData[1] = mashreq
            this.balanceAccountsRowsData[2] = rak
            this.balanceAccountsRowsData[3] = creditCard
            this.balanceAccountsRowsData[4] = cash
            this.balanceAccountsRowsData[5] = partners
            this.balanceAccountsRowsData[6] = vat
          }
          this.getCacheTotalBalance()
          _.forEach(this.balanceAccountsRowsData, item => {
            this.addEditAccess(item)
          })
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    setBalance (category, balance, debit) {
      const row = _.find(this.balanceAccountsRowsData, {category: category})
      if (debit) {
        this.$set(row, 'debit', debit)
      }
      if (row) {
        this.$set(row, 'balanceAED', balance)
        return true
      }
      return false
    },
    getCacheTotalBalance () {
      CacheApi.getCacheTotal({})
        .then((resp) => {
          const cash = _.find(this.balanceAccountsRowsData, {category: 3}) || {}
          const balance = resp.data.totalBalanceAed || 0
          cash.credit = balance
          cash.debit = 0
          this.getBankDetailsTotal(balance)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getBankDetailsTotal (balanceCash) {
      balanceAccountsApi.getBankBalanceTotal()
        .then((resp) => {
          let totalCredit = resp.data.totalBanks + resp.data.totalCredit
          let totalCash = totalCredit + balanceCash
          let totalPartners = totalCash - resp.data.totalPartners
          let totalVat = totalPartners + resp.data.totalVat
          this.setBalance(2, totalCredit)
          this.setBalance(3, totalCash)
          this.setBalance(4, totalVat)
          this.setBalance(5, totalPartners, Math.abs(resp.data.totalPartners))
          const sum = totalVat
          const total = this.setBalance('total', sum)
          if (!total) {
            const newTotal = {
              id: 'total',
              category: 'total',
              name: 'Total',
              balanceAED: sum,
              static: true
            }
            this.balanceAccountsRowsData.push(newTotal)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    createBankBalance (bankBalance) {
      balanceAccountsApi.createBankBalance(bankBalance)
        .then((resp) => {
          this.balanceAccountsRowsData.push(resp.data)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    editBankBalance (bankBalance) {
      const index = _.findIndex(this.balanceAccountsRowsData, {id: bankBalance.id})
      balanceAccountsApi.editBankBalance(bankBalance)
        .then((resp) => {
          this.addEditAccess(resp.data)
          this.balanceAccountsRowsData.splice(index, 1, resp.data)
          this.getCacheTotalBalance()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    createStartBanks () {
      _.forEach(this.bankBalances, item => {
        this.createBankBalance(item)
      })
      this.getBankDetails()
    }
  },
  beforeMount () {
    this.balanceAccountsColumnsData = balanceAccountsTableColumns
    this.addActions()
    this.getBankDetails()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-balance-accounts {
    margin-top: 47px;
    max-width: 1016px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/AssetsMaterialsRecords/AssetsMaterialsRecords.vue